import store from '../../../../store/store';
import { PerformCreateSearchParams } from '../interfaces/create-search.interface';
import { StoreState } from '../../../../store/store.interface';
import { getCreateSearchApiCall } from '../api/create-search.api';
import { onCreateSearchFailure, onCreateSearchSuccess, setCreateSearchLoading } from '../store/create-search.store';
import { selectCreateRequest } from '../store/create-search.selector';

/*----- DECLARE THUNKS ------*/
export const performCreateSearch = (params: PerformCreateSearchParams = {}, useOldRequest = true) => async (
  dispatch: Function,
  getState: Function
): Promise<any> => {
  const request = getCreateSearchRequest(params, getState(), useOldRequest);

  dispatch(setCreateSearchLoading(request));

  try {
    const searchData = await getCreateSearchApiCall(request);
    if (searchData) {
      dispatch(onCreateSearchSuccess(searchData));
      return searchData;
    } else {
      dispatch(onCreateSearchFailure());
      return {};
    }
  } catch (error) {
    store.dispatch(onCreateSearchFailure());
  }
};

/**
 * Generates the search request for the Create search feature.
 * This function takes in the new parameters for the search request and the current state of the store.
 * It also takes a boolean indicating whether to use the old request as a base for the new request.
 *
 * @param params
 * @param state
 * @param useOldRequest
 */
export function getCreateSearchRequest(
  params: PerformCreateSearchParams,
  state: StoreState,
  useOldRequest = true
): PerformCreateSearchParams {
  let oldRequest: PerformCreateSearchParams;
  let request: PerformCreateSearchParams;
  if (useOldRequest) {
    oldRequest = { ...selectCreateRequest(state) };
    if (!oldRequest) {
      oldRequest = {
        hits: true,
        searchValue: '',
        pageSize: 10,
        start: 0,
        facets: true,
      };
    }

    if (params.clearFilter) {
      oldRequest.fieldValueFilter = undefined;
    }

    oldRequest.addFacetName = undefined;
    oldRequest.addFacetValue = undefined;
    oldRequest.removeFacetName = undefined;
    oldRequest.removeFacetValue = undefined;
    request = { ...JSON.parse(JSON.stringify(oldRequest)), ...params };
  } else {
    request = { ...params };
  }

  if (!request.fieldValueFilter) {
    request.fieldValueFilter = {};
  }

  if (params.addFacetName && !request.fieldValueFilter[params.addFacetName]) {
    request.fieldValueFilter[params.addFacetName] = [];
  }

  if (params.addFacetName && params.addFacetValue) {
    request.fieldValueFilter[params.addFacetName] = request.fieldValueFilter[params.addFacetName].filter((facet) => {
      if (params.addFacetValue) {
        return !params.addFacetValue.startsWith(facet) && !facet.startsWith(params.addFacetValue);
      }
      return true;
    });

    request.fieldValueFilter[params.addFacetName].push(params.addFacetValue);
  }

  if (params.changeFacetName && params.changeFacetValue) {
    request.fieldValueFilter[params.changeFacetName] = [params.changeFacetValue];
  }

  if (params.removeFacetName && !request.fieldValueFilter[params.removeFacetName]) {
    request.fieldValueFilter[params.removeFacetName] = [];
  }

  if (params.removeFacetName && params.removeFacetValue) {
    request.fieldValueFilter[params.removeFacetName] = request.fieldValueFilter[params.removeFacetName].filter(
      (value: string) => value != params.removeFacetValue
    );

    if (request.fieldValueFilter[params.removeFacetName].length === 0) {
      delete request.fieldValueFilter[params.removeFacetName];
    }
  }

  if (!request.pageSize) {
    request.pageSize = 10;
  }

  return request;
}
